import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useSubstitutionPlan(substitutionPlanId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["substitutionPlans", substitutionPlanId ?? ""],
		queryFn: async () => {
			if (!substitutionPlanId) throw Error;
			const response = await client.users.substitutions[":substitutionPlanId"].$get({
				param: { substitutionPlanId },
			});
			const data = await responseHandler(response);
			return data.substitutionPlan;
		},
		enabled: !!substitutionPlanId,
	});

	return { ...query, substitutionPlan: query.data };
}
